import { FC } from "react";
import { IncreaseOfShareCapitalForm } from "./increaseOfShareCapitalDomain";
import { observer } from "mobx-react";
import { VBox } from "../../components-v2/Box";
import { MCheckboxGroup } from "../../components-v2/Checkbox";

import { useTranslation } from "../../stores/RootStoreContext";

const ShareCapitalIncreaseMethod: FC<{ form: IncreaseOfShareCapitalForm }> = observer(
  ({ form }) => {
    const { t } = useTranslation();
    return (
      <VBox>
        <div>{t("decisions.increaseShareCapitalAgainstCash.selectIncreaseType")}</div>
        <MCheckboxGroup model={form.contributionTypes} disabled={form.isProjectLocked} />
      </VBox>
    );
  },
);

export default ShareCapitalIncreaseMethod;
